import { locate } from "./html";

export interface IFocusManager {
	getFocusId(): string;
	setFocusId(id: string): void;
}

class FocusManager implements IFocusManager {
	private _activeWidgetId: string;
	private _initHandler = (e: Event) => (this._activeWidgetId = locate(e, "dhx_widget_id"));

	constructor() {
		document.addEventListener("focusin", this._initHandler);
		document.addEventListener("click", this._initHandler);
	}

	getFocusId(): string {
		return this._activeWidgetId;
	}

	setFocusId(id: string): void {
		this._activeWidgetId = id;
	}
}

export const focusManager = new FocusManager();
